// extracted by mini-css-extract-plugin
export var activityContainer = "_mq-0";
export var typingIndicatorContainer = "_mq-1";
export var typingIndicatorDot = "_mq-2";
export var wave = "_mq-3";